import html2canvas from 'html2canvas';
import { jsPDF as JSPDF } from 'jspdf';

const normalizeFileName = (fileName: string): string => {
  const regexp = /^[@#$%^&\\\-_ +=<>()/'"!*,.?;:]+$/;
  return fileName
    .split('')
    .map((char) => (regexp.test(char) ? '' : char))
    .join('');
};

/**
 * Renders a DOM subtree to a multi-page A4 PDF (portrait). Used for “flat” exports of
 * in-app content (e.g. calculator package detail) without the campaign-schedule template.
 */
export async function exportDomElementToPdf(element: HTMLElement, fileName: string): Promise<void> {
  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    logging: false,
    backgroundColor: '#ffffff',
    scrollX: 0,
    scrollY: -window.scrollY
  });

  const pdf = new JSPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const imgWidth = pageWidth;
  const imgHeightMm = (canvas.height * imgWidth) / canvas.width;

  let positionMm = 0;
  while (positionMm < imgHeightMm) {
    if (positionMm > 0) pdf.addPage();
    const sliceMm = Math.min(pageHeight, imgHeightMm - positionMm);
    const srcY = (positionMm / imgHeightMm) * canvas.height;
    const srcH = (sliceMm / imgHeightMm) * canvas.height;

    const sliceCanvas = document.createElement('canvas');
    sliceCanvas.width = canvas.width;
    sliceCanvas.height = Math.max(1, Math.ceil(srcH));
    const ctx = sliceCanvas.getContext('2d');
    if (!ctx) throw new Error('Canvas 2D context unavailable');
    ctx.drawImage(canvas, 0, srcY, canvas.width, srcH, 0, 0, canvas.width, srcH);

    const sliceData = sliceCanvas.toDataURL('image/jpeg', 0.92);
    pdf.addImage(sliceData, 'JPEG', 0, 0, imgWidth, sliceMm, undefined, 'MEDIUM');
    positionMm += sliceMm;
  }

  const safeName = normalizeFileName(fileName) || 'export';
  pdf.save(`${safeName}.pdf`);
}
